// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1pOli","col":"styles_col__3P3vz","fulfillmentStatus":"styles_fulfillmentStatus__D1ePY","emailCol":"styles_emailCol__p0pYF"};